import { appSettings } from './../../../../environments/app.setings';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FichaService } from '../../ficha-veiculo.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomModalService } from '../../../shared/modais/custom-modal/custom-modal.service';
import { FichaModalAvalistaComponent } from '../ficha-modal-avalista/ficha-modal-avalista.component';
import { AvalistaComponent } from '../ficha-timeline-sos/avalista/avalista.component';
import { FichaCadastro } from '../../ficha-cadastro/ficha-cadastro';
import { Cliente } from '../../ficha-cadastro/model/cliente';
import { finalize } from 'rxjs';
import * as toastr from 'toastr';

@Component({
  selector: 'app-ficha-timeline-add-avalista',
  templateUrl: './ficha-timeline-add-avalista.component.html',
  styleUrls: ['./ficha-timeline-add-avalista.component.css'],
})
export class FichaTimelineAddAvalistaComponent implements OnInit {
  @ViewChild(AvalistaComponent, { static: true })
  private avalistaComponent: AvalistaComponent;
  @Input() proposta: any;
  @Input() idFicha: any;
  @Input() cpfCliente: any;
  bsModalRef: BsModalRef;
  isHabilitarAddAvalista: boolean = false;
  fichaCadastro: FichaCadastro;
  @Output() isSavingAvalista = new EventEmitter<boolean>();
  constructor(
    private fichaService: FichaService,
    private modalService: CustomModalService
  ) {}

  ngOnInit() {
    this.fichaCadastro = new FichaCadastro();
    this.fichaCadastro.setCliente(new Cliente());

    this.fichaCadastro.limiteRenda = {
      ...this.proposta._fichaTimeline.timelineProposta.produtoProposta,
    };

    this.idFicha = this.proposta.proposta.id;
    this.isHabilitarAddAvalista =
      (this.proposta.status === 2 ||
        this.proposta.status === 3 ||
        this.proposta.status === 4 ||
        this.proposta.status === 5 ||
        this.proposta.status === 6 ||
        this.proposta.status === 7) &&
      this.proposta.proposta.possuiAvalista === 'N';
  }

  abrirInclusaoAvalista() {
    const initialState = {
      fichaCadastro: this.fichaCadastro,
      avalistasIncluidos: [],
    };
    this.bsModalRef = this.modalService.show(FichaModalAvalistaComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });
    this.bsModalRef.content.cpfCliente = this.proposta.cliente.cpf;
    (<FichaModalAvalistaComponent>(
      this.bsModalRef.content
    )).onCloseModal.subscribe((body) => {
      this.isSavingAvalista.emit(true);
      this.proposta = body;
      this.proposta.id = this.idFicha;
      this.fichaService
        .pushAvalista({ proposta: this.proposta })
        .pipe(
          finalize(() => {
            this.isSavingAvalista.emit(false);
          })
        )
        .subscribe({
          next: () => {
            this.isHabilitarAddAvalista = false;
          },
          error: (error: any) => {
            console.log(error);
            toastr.error(error.error.message, 'Por favor tente novamente');
          },
        });
    });
  }
}
